import {basePageableGraphqlField, responseField} from "../../../base.graphql";
import {gql} from "graphql-tag";
import {deviceFields} from "../../warehouse-management/device/device.graphql";


export const humidityGraphFields = `
    id
    uniqueId
    timestamp
    humidity
    sensor {
        ${deviceFields}
    }
`;

export const temperatureGraphFields = `
    id
    uniqueId
    timestamp
    temperature
    sensor {
        ${deviceFields}
    }
`;
export const dashboardData =`
dashboardData
`;

// Queries
export const GET_HUMIDITY_GRAPH_DATA = gql`
    query getHumidityGraphData($filtering: ReadingsFilteringObject) {
        getHumidityGraphData(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                ${humidityGraphFields}
            }
            page {
                ${basePageableGraphqlField}
            }
        }
    }
`;

export const GET_TEMPERATURE_GRAPH_DATA = gql`
    query getTemperatureGraphData($filtering: ReadingsFilteringObject) {
        getTemperatureGraphData(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                ${temperatureGraphFields}
            }
            page {
                ${basePageableGraphqlField}
            }
        }
    }
    
`;

export const GET_WAREHOUSE_LATEST_READINGS = gql`
    query getWarehouseLatestReadings($filtering: DrillDownFilteringInputObject) {
        getWarehouseLatestReadings(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                ${dashboardData}
            }
            page {
                ${basePageableGraphqlField}
            }
        }
    }
    
`;